import { RCCCustomServicesApi } from "react-common-components";
import IBaseDTO from "src/Interfaces/baseDTO";

export interface ISuggestions extends IBaseDTO {
    Sga001Id: number;
    Sga001Titulo: string;
    Sga001Descricao: string;
    Sga001Situacao: SuggestionSituation;
    Sga001Data: string;
    DataUltimoComentario: string | null;
    Sgu001Nomeempresa: string;
    Sgu001Nomeusuario: string;
    Sgtba004: {
        Efa018Descricao: string;
    }[];
    QtdeAvaliacoesNegativas: number;
    QtdeAvaliacoesPositivas: number;
    QtdeComentarios: number;
    AvaliacaoUsuario: number;
}

export interface IRefSuggestionsModals {
    actionButtonAdd: () => void;
    actionButtonView: (suggestion: ISuggestions) => void;
}

export interface IComponentSuggestionsModals {
    reload: () => void;
    CustomServicesApi: RCCCustomServicesApi;
    optionsMarkers: {
        value: string;
        label: string;
    }[];
}

export enum SuggestionSituation{
    WAITING_ANALYSIS = 1,
    ANALYSIS = 2,
    APPROVED = 3,
    FAILED = 4,
    FINISHED = 5,
    CANCELED = 6
}
